import { tategaki, tategakiStroke } from './verticalWriter';
import { BLACK_COLOR, WHITE_COLOR } from './variables';

export const writeVertical = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number,
    text: string,
    font: string,
    stroke = false,
): void => {
    ctx.save();

    ctx.font = font;
    ctx.fillStyle = BLACK_COLOR;
    ctx.fillRect(0, 0, width, height);
    const lw = ctx.measureText('あ').width;
    const center = width / 2 - lw / 2;
    const padding = 40;
    if (stroke) {
        tategakiStroke(ctx, text, center, padding);
    } else {
        tategaki(ctx, text, center, padding);
    }

    ctx.restore();
};

export const writeHorizontal = (
    ctx: CanvasRenderingContext2D,
    width: number,
    height: number,
    text: string,
    font: string,
): void => {
    ctx.save();

    ctx.font = font;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = BLACK_COLOR;
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = WHITE_COLOR;
    const center = -(width + 40);
    const padding = width / 2;
    const angle = 270;
    ctx.rotate((angle * Math.PI) / 180);
    ctx.fillText(text, center, padding);

    ctx.restore();
};
